module.exports = __webpack_public_path__ + "static/img/techs3.e1b02d6e.png";